import { useEffect } from "react";
import { Link } from "react-router-dom";
import { applyPageSeo } from "../lib/seo";

const popularTemplates = [
  { brand: "airbnb", slug: "booking-confirmation", label: "Airbnb Booking Confirmation" },
  { brand: "stripe", slug: "payment-receipt", label: "Stripe Payment Receipt" },
  { brand: "slack", slug: "welcome", label: "Slack Welcome Email" },
  { brand: "netflix", slug: "subscription-confirmation", label: "Netflix Subscription" },
  { brand: "spotify", slug: "wrapped-summary", label: "Spotify Wrapped" },
  { brand: "shopify", slug: "order-confirmation", label: "Shopify Order Confirmation" },
];

export function NotFound() {
  useEffect(() => {
    return applyPageSeo({
      title: "Page Not Found",
      description: "The page you\u0027re looking for doesn\u0027t exist. Browse our email templates or go to the homepage.",
      path: "/404",
      robots: "noindex,nofollow",
    });
  }, []);

  return (
    <main className="bg-[radial-gradient(circle_at_top,_rgba(14,165,233,0.1),_transparent_38%),linear-gradient(180deg,_#f8fafc_0%,_#ffffff_50%,_#f8fafc_100%)]">
      <div className="mx-auto max-w-2xl px-4 py-24 text-center sm:py-32">
        <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-md border border-slate-200 bg-white shadow-sm">
          <span className="text-3xl font-bold text-slate-300">404</span>
        </div>
        <h1 className="mt-8 text-4xl font-semibold tracking-tight text-slate-950 sm:text-5xl">
          Page not found
        </h1>
        <p className="mt-4 text-lg leading-8 text-slate-600">
          Sorry, we couldn't find the page you're looking for. It may have been moved or removed.
        </p>
        <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-md bg-slate-950 px-5 py-2.5 text-sm font-semibold text-white transition hover:bg-slate-800"
          >
            Go home
            <svg aria-hidden="true" className="h-4 w-4" viewBox="0 0 20 20" fill="none">
              <path d="M4.166 10h11.667m0 0-4.167-4.167M15.833 10l-4.167 4.167" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </Link>
          <Link
            to="/discover/templates"
            className="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 transition hover:border-slate-400 hover:bg-slate-50"
          >
            Browse templates
          </Link>
        </div>

        <div className="mt-16">
          <p className="text-sm font-semibold uppercase tracking-[0.24em] text-sky-700">
            Popular templates
          </p>
          <p className="mt-2 text-base text-slate-600">
            Try one of these instead:
          </p>
          <div className="mt-6 grid gap-3 sm:grid-cols-2">
            {popularTemplates.map((t) => (
              <Link
                key={`${t.brand}/${t.slug}`}
                to={`/templates/${t.brand}/${t.slug}`}
                className="rounded-md border border-slate-200 bg-white p-4 text-left transition hover:-translate-y-0.5 hover:shadow-md"
              >
                <span className="rounded-md bg-slate-100 px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wider text-slate-700">
                  {t.brand.charAt(0).toUpperCase() + t.brand.slice(1)}
                </span>
                <p className="mt-2 text-sm font-semibold text-slate-950">{t.label}</p>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
}
